package ru.villawonka.app.domain.model

data class PostSourceDomain(
    val name: String,
    val imageUrl: String,
    val isTrusted: Boolean,
    val postUrl: String,
    val platform: String,
)